// programmatically generated file

const {gql} = require("@apollo/client")


module.exports = class Mutation {
    constructor(client) {
        this.client = client
    }

    async logIn ({email, password, totp, privateCloud}) {
        if(email === undefined) throw new Error('email is a required argument')
        const email_arg = `email:"${email}",`
        if(password === undefined) throw new Error('password is a required argument')
        const password_arg = `password:"${password}",`
        const totp_arg = totp !== undefined ? totp === null ? `totp: null,` : `totp:"${totp}",` : ''
        const privateCloud_arg = privateCloud !== undefined ? privateCloud === null ? `privateCloud: null,` : `privateCloud:"${privateCloud}",` : ''
        return this.client.mutate({ mutation:gql(`mutation{logIn(${email_arg}${password_arg}${totp_arg}${privateCloud_arg})}`) }).then(res=>res.data.logIn)
        }
    
    async createAccessToken ({name, password}) {
        if(name === undefined) throw new Error('name is a required argument')
        const name_arg = `name:"${name}",`
        if(password === undefined) throw new Error('password is a required argument')
        const password_arg = `password:"${password}",`
        
        return this.client.mutate({ mutation:gql(`mutation{createAccessToken(${name_arg}${password_arg}){id}}`) }).then(res=>res.data.createAccessToken)
        }
    
    async regenerateAccessToken ({id, password}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        if(password === undefined) throw new Error('password is a required argument')
        const password_arg = `password:"${password}",`
        
        return this.client.mutate({ mutation:gql(`mutation{regenerateAccessToken(${id_arg}${password_arg})}`) }).then(res=>res.data.regenerateAccessToken)
        }
    
    async deleteAccessToken ({id, password}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        if(password === undefined) throw new Error('password is a required argument')
        const password_arg = `password:"${password}",`
        
        return this.client.mutate({ mutation:gql(`mutation{deleteAccessToken(${id_arg}${password_arg})}`) }).then(res=>res.data.deleteAccessToken)
        }
    
    async signUp ({email, name, password, acceptPrivacyPolicy, privateCloud}) {
        if(email === undefined) throw new Error('email is a required argument')
        const email_arg = `email:"${email}",`
        if(name === undefined) throw new Error('name is a required argument')
        const name_arg = `name:"${name}",`
        if(password === undefined) throw new Error('password is a required argument')
        const password_arg = `password:"${password}",`
        if(acceptPrivacyPolicy === undefined) throw new Error('acceptPrivacyPolicy is a required argument')
        const acceptPrivacyPolicy_arg = `acceptPrivacyPolicy:${acceptPrivacyPolicy},`
        const privateCloud_arg = privateCloud !== undefined ? privateCloud === null ? `privateCloud: null,` : `privateCloud:"${privateCloud}",` : ''
        return this.client.mutate({ mutation:gql(`mutation{signUp(${email_arg}${name_arg}${password_arg}${acceptPrivacyPolicy_arg}${privateCloud_arg})}`) }).then(res=>res.data.signUp)
        }
    
    async acceptLegalDocuments ({privacyPolicy}) {
        
        const privacyPolicy_arg = privacyPolicy !== undefined ? privacyPolicy === null ? `privacyPolicy: null,` : `privacyPolicy:"${privacyPolicy}",` : ''
        return this.client.mutate({ mutation:gql(`mutation{acceptLegalDocuments(${privacyPolicy_arg})}`) }).then(res=>res.data.acceptLegalDocuments)
        }
    
    async initiateBillingSetup () {
        
        
        return this.client.mutate({ mutation:gql(`mutation{initiateBillingSetup}`) }).then(res=>res.data.initiateBillingSetup)
        }
    
    async updatePaymentMethod ({stripePaymentMethod}) {
        
        const stripePaymentMethod_arg = stripePaymentMethod !== undefined ? stripePaymentMethod === null ? `stripePaymentMethod: null,` : `stripePaymentMethod:"${stripePaymentMethod}",` : ''
        return this.client.mutate({ mutation:gql(`mutation{updatePaymentMethod(${stripePaymentMethod_arg})}`) }).then(res=>res.data.updatePaymentMethod)
        }
    
    async confirmPaymentExecution () {
        
        
        return this.client.mutate({ mutation:gql(`mutation{confirmPaymentExecution}`) }).then(res=>res.data.confirmPaymentExecution)
        }
    
    async retryPayment () {
        
        
        return this.client.mutate({ mutation:gql(`mutation{retryPayment}`) }).then(res=>res.data.retryPayment)
        }
    
    async changePassword ({newPassword, oldPassword}) {
        if(newPassword === undefined) throw new Error('newPassword is a required argument')
        const newPassword_arg = `newPassword:"${newPassword}",`
        if(oldPassword === undefined) throw new Error('oldPassword is a required argument')
        const oldPassword_arg = `oldPassword:"${oldPassword}",`
        
        return this.client.mutate({ mutation:gql(`mutation{changePassword(${newPassword_arg}${oldPassword_arg})}`) }).then(res=>res.data.changePassword)
        }
    
    async setTotp ({totp, secret, password}) {
        if(totp === undefined) throw new Error('totp is a required argument')
        const totp_arg = `totp:"${totp}",`
        if(secret === undefined) throw new Error('secret is a required argument')
        const secret_arg = `secret:"${secret}",`
        if(password === undefined) throw new Error('password is a required argument')
        const password_arg = `password:"${password}",`
        
        return this.client.mutate({ mutation:gql(`mutation{setTotp(${totp_arg}${secret_arg}${password_arg})}`) }).then(res=>res.data.setTotp)
        }
    
    async disableTotp ({password}) {
        if(password === undefined) throw new Error('password is a required argument')
        const password_arg = `password:"${password}",`
        
        return this.client.mutate({ mutation:gql(`mutation{disableTotp(${password_arg})}`) }).then(res=>res.data.disableTotp)
        }
    
    async sendDisableTotpEmail ({email, redirectTo}) {
        if(email === undefined) throw new Error('email is a required argument')
        const email_arg = `email:"${email}",`
        if(redirectTo === undefined) throw new Error('redirectTo is a required argument')
        const redirectTo_arg = `redirectTo:${redirectTo},`
        
        return this.client.mutate({ mutation:gql(`mutation{sendDisableTotpEmail(${email_arg}${redirectTo_arg})}`) }).then(res=>res.data.sendDisableTotpEmail)
        }
    
    async sendVerificationEmail ({redirectTo}) {
        if(redirectTo === undefined) throw new Error('redirectTo is a required argument')
        const redirectTo_arg = `redirectTo:${redirectTo},`
        
        return this.client.mutate({ mutation:gql(`mutation{sendVerificationEmail(${redirectTo_arg})}`) }).then(res=>res.data.sendVerificationEmail)
        }
    
    async sendPasswordRecoveryEmail ({redirectTo, email}) {
        if(redirectTo === undefined) throw new Error('redirectTo is a required argument')
        const redirectTo_arg = `redirectTo:${redirectTo},`
        if(email === undefined) throw new Error('email is a required argument')
        const email_arg = `email:"${email}",`
        
        return this.client.mutate({ mutation:gql(`mutation{sendPasswordRecoveryEmail(${redirectTo_arg}${email_arg})}`) }).then(res=>res.data.sendPasswordRecoveryEmail)
        }
    
    async resetPassword ({recoveryToken, newPassword}) {
        if(recoveryToken === undefined) throw new Error('recoveryToken is a required argument')
        const recoveryToken_arg = `recoveryToken:"${recoveryToken}",`
        if(newPassword === undefined) throw new Error('newPassword is a required argument')
        const newPassword_arg = `newPassword:"${newPassword}",`
        
        return this.client.mutate({ mutation:gql(`mutation{resetPassword(${recoveryToken_arg}${newPassword_arg})}`) }).then(res=>res.data.resetPassword)
        }
    
    async shareCollection ({collectionId, role, email, userId}) {
        if(collectionId === undefined) throw new Error('collectionId is a required argument')
        const collectionId_arg = `collectionId:"${collectionId}",`
        if(role === undefined) throw new Error('role is a required argument')
        const role_arg = `role:${role},`
        const email_arg = email !== undefined ? email === null ? `email: null,` : `email:"${email}",` : ''
        const userId_arg = userId !== undefined ? userId === null ? `userId: null,` : `userId:"${userId}",` : ''
        return this.client.mutate({ mutation:gql(`mutation{shareCollection(${collectionId_arg}${email_arg}${userId_arg}${role_arg}){id}}`) }).then(res=>res.data.shareCollection)
        }
    
    async pendingShare ({id, role}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        if(role === undefined) throw new Error('role is a required argument')
        const role_arg = `role:${role},`
        
        return this.client.mutate({ mutation:gql(`mutation{pendingShare(${id_arg}${role_arg}){id}}`) }).then(res=>res.data.pendingShare)
        }
    
    async revokePendingShare ({id}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        
        return this.client.mutate({ mutation:gql(`mutation{revokePendingShare(${id_arg})}`) }).then(res=>res.data.revokePendingShare)
        }
    
    async acceptPendingShare ({id}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        
        return this.client.mutate({ mutation:gql(`mutation{acceptPendingShare(${id_arg}){id}}`) }).then(res=>res.data.acceptPendingShare)
        }
    
    async declinePendingShare ({id}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        
        return this.client.mutate({ mutation:gql(`mutation{declinePendingShare(${id_arg})}`) }).then(res=>res.data.declinePendingShare)
        }
    
    async stopSharingCollection ({collectionId, email, userId}) {
        if(collectionId === undefined) throw new Error('collectionId is a required argument')
        const collectionId_arg = `collectionId:"${collectionId}",`
        const email_arg = email !== undefined ? email === null ? `email: null,` : `email:"${email}",` : ''
        const userId_arg = userId !== undefined ? userId === null ? `userId: null,` : `userId:"${userId}",` : ''
        return this.client.mutate({ mutation:gql(`mutation{stopSharingCollection(${collectionId_arg}${email_arg}${userId_arg}){id}}`) }).then(res=>res.data.stopSharingCollection)
        }
    
    async leaveCollection ({id}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        
        return this.client.mutate({ mutation:gql(`mutation{leaveCollection(${id_arg})}`) }).then(res=>res.data.leaveCollection)
        }
    
    async transferCollection ({collectionId, email, userId}) {
        if(collectionId === undefined) throw new Error('collectionId is a required argument')
        const collectionId_arg = `collectionId:"${collectionId}",`
        const email_arg = email !== undefined ? email === null ? `email: null,` : `email:"${email}",` : ''
        const userId_arg = userId !== undefined ? userId === null ? `userId: null,` : `userId:"${userId}",` : ''
        return this.client.mutate({ mutation:gql(`mutation{transferCollection(${collectionId_arg}${email_arg}${userId_arg}){id}}`) }).then(res=>res.data.transferCollection)
        }
    
    async revokePendingTransfer ({id}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        
        return this.client.mutate({ mutation:gql(`mutation{revokePendingTransfer(${id_arg})}`) }).then(res=>res.data.revokePendingTransfer)
        }
    
    async acceptPendingTransfer ({id}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        
        return this.client.mutate({ mutation:gql(`mutation{acceptPendingTransfer(${id_arg}){id}}`) }).then(res=>res.data.acceptPendingTransfer)
        }
    
    async declinePendingTransfer ({id}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        
        return this.client.mutate({ mutation:gql(`mutation{declinePendingTransfer(${id_arg})}`) }).then(res=>res.data.declinePendingTransfer)
        }
    
    async changeRole ({collectionId, newRole, email, userId}) {
        if(collectionId === undefined) throw new Error('collectionId is a required argument')
        const collectionId_arg = `collectionId:"${collectionId}",`
        if(newRole === undefined) throw new Error('newRole is a required argument')
        const newRole_arg = `newRole:${newRole},`
        const email_arg = email !== undefined ? email === null ? `email: null,` : `email:"${email}",` : ''
        const userId_arg = userId !== undefined ? userId === null ? `userId: null,` : `userId:"${userId}",` : ''
        return this.client.mutate({ mutation:gql(`mutation{changeRole(${collectionId_arg}${email_arg}${userId_arg}${newRole_arg}){id}}`) }).then(res=>res.data.changeRole)
        }
    
    async createCollection ({name, picture, index, muted}) {
        if(name === undefined) throw new Error('name is a required argument')
        const name_arg = `name:"${name}",`
        const picture_arg = picture !== undefined ? picture === null ? `picture: null,` : `picture:${picture},` : ''
        const index_arg = index !== undefined ? index === null ? `index: null,` : `index:${index},` : ''
        const muted_arg = muted !== undefined ? muted === null ? `muted: null,` : `muted:${muted},` : ''
        return this.client.mutate({ mutation:gql(`mutation{createCollection(${name_arg}${picture_arg}${index_arg}${muted_arg}){id}}`) }).then(res=>res.data.createCollection)
        }
    
    async createThing ({type, firmware, storedNotifications}) {
        if(type === undefined) throw new Error('type is a required argument')
        const type_arg = `type:"${type}",`
        const firmware_arg = firmware !== undefined ? firmware === null ? `firmware: null,` : `firmware:"${firmware}",` : ''
        const storedNotifications_arg = storedNotifications !== undefined ? storedNotifications === null ? `storedNotifications: null,` : `storedNotifications:${storedNotifications},` : ''
        return this.client.mutate({ mutation:gql(`mutation{createThing(${type_arg}${firmware_arg}${storedNotifications_arg}){id}}`) }).then(res=>res.data.createThing)
        }
    
    async pairThing ({pairCode, name, collectionId, index}) {
        if(pairCode === undefined) throw new Error('pairCode is a required argument')
        const pairCode_arg = `pairCode:"${pairCode}",`
        if(name === undefined) throw new Error('name is a required argument')
        const name_arg = `name:"${name}",`
        if(collectionId === undefined) throw new Error('collectionId is a required argument')
        const collectionId_arg = `collectionId:"${collectionId}",`
        const index_arg = index !== undefined ? index === null ? `index: null,` : `index:${index},` : ''
        return this.client.mutate({ mutation:gql(`mutation{pairThing(${pairCode_arg}${name_arg}${index_arg}${collectionId_arg}){id}}`) }).then(res=>res.data.pairThing)
        }
    
    async createNotification ({content, thingId, timestamp}) {
        if(content === undefined) throw new Error('content is a required argument')
        const content_arg = `content:"${content}",`
        const thingId_arg = thingId !== undefined ? thingId === null ? `thingId: null,` : `thingId:"${thingId}",` : ''
        const timestamp_arg = timestamp !== undefined ? timestamp === null ? `timestamp: null,` : `timestamp:${timestamp},` : ''
        return this.client.mutate({ mutation:gql(`mutation{createNotification(${thingId_arg}${content_arg}${timestamp_arg}){id}}`) }).then(res=>res.data.createNotification)
        }
    
    async createFloatVariable ({userPermission, name, thingId, developerOnly, unitOfMeasurement, value, precision, min, max, index, allowedValues}) {
        if(userPermission === undefined) throw new Error('userPermission is a required argument')
        const userPermission_arg = `userPermission:${userPermission},`
        if(name === undefined) throw new Error('name is a required argument')
        const name_arg = `name:"${name}",`
        const thingId_arg = thingId !== undefined ? thingId === null ? `thingId: null,` : `thingId:"${thingId}",` : ''
        const developerOnly_arg = developerOnly !== undefined ? developerOnly === null ? `developerOnly: null,` : `developerOnly:${developerOnly},` : ''
        const unitOfMeasurement_arg = unitOfMeasurement !== undefined ? unitOfMeasurement === null ? `unitOfMeasurement: null,` : `unitOfMeasurement:"${unitOfMeasurement}",` : ''
        const value_arg = value !== undefined ? value === null ? `value: null,` : `value:${value},` : ''
        const precision_arg = precision !== undefined ? precision === null ? `precision: null,` : `precision:${precision},` : ''
        const min_arg = min !== undefined ? min === null ? `min: null,` : `min:${min},` : ''
        const max_arg = max !== undefined ? max === null ? `max: null,` : `max:${max},` : ''
        const index_arg = index !== undefined ? index === null ? `index: null,` : `index:${index},` : ''
        const allowedValues_arg = allowedValues !== undefined ? allowedValues === null ? `allowedValues: null,` : `allowedValues:${allowedValues},` : ''
        return this.client.mutate({ mutation:gql(`mutation{createFloatVariable(${thingId_arg}${userPermission_arg}${developerOnly_arg}${unitOfMeasurement_arg}${value_arg}${precision_arg}${min_arg}${max_arg}${name_arg}${index_arg}${allowedValues_arg}){id}}`) }).then(res=>res.data.createFloatVariable)
        }
    
    async createStringVariable ({userPermission, name, thingId, developerOnly, value, maxCharacters, allowedValues, index}) {
        if(userPermission === undefined) throw new Error('userPermission is a required argument')
        const userPermission_arg = `userPermission:${userPermission},`
        if(name === undefined) throw new Error('name is a required argument')
        const name_arg = `name:"${name}",`
        const thingId_arg = thingId !== undefined ? thingId === null ? `thingId: null,` : `thingId:"${thingId}",` : ''
        const developerOnly_arg = developerOnly !== undefined ? developerOnly === null ? `developerOnly: null,` : `developerOnly:${developerOnly},` : ''
        const value_arg = value !== undefined ? value === null ? `value: null,` : `value:"${value}",` : ''
        const maxCharacters_arg = maxCharacters !== undefined ? maxCharacters === null ? `maxCharacters: null,` : `maxCharacters:${maxCharacters},` : ''
        const allowedValues_arg = allowedValues !== undefined ? allowedValues === null ? `allowedValues: null,` : `allowedValues:${allowedValues},` : ''
        const index_arg = index !== undefined ? index === null ? `index: null,` : `index:${index},` : ''
        return this.client.mutate({ mutation:gql(`mutation{createStringVariable(${thingId_arg}${userPermission_arg}${developerOnly_arg}${value_arg}${maxCharacters_arg}${name_arg}${allowedValues_arg}${index_arg}){id}}`) }).then(res=>res.data.createStringVariable)
        }
    
    async createBooleanVariable ({userPermission, name, thingId, developerOnly, value, index}) {
        if(userPermission === undefined) throw new Error('userPermission is a required argument')
        const userPermission_arg = `userPermission:${userPermission},`
        if(name === undefined) throw new Error('name is a required argument')
        const name_arg = `name:"${name}",`
        const thingId_arg = thingId !== undefined ? thingId === null ? `thingId: null,` : `thingId:"${thingId}",` : ''
        const developerOnly_arg = developerOnly !== undefined ? developerOnly === null ? `developerOnly: null,` : `developerOnly:${developerOnly},` : ''
        const value_arg = value !== undefined ? value === null ? `value: null,` : `value:${value},` : ''
        const index_arg = index !== undefined ? index === null ? `index: null,` : `index:${index},` : ''
        return this.client.mutate({ mutation:gql(`mutation{createBooleanVariable(${thingId_arg}${userPermission_arg}${developerOnly_arg}${value_arg}${name_arg}${index_arg}){id}}`) }).then(res=>res.data.createBooleanVariable)
        }
    
    async createFloatSeriesVariable ({name, thingId, developerOnly, unitOfMeasurement, precision, min, max, index, shownNodes, storedNodes}) {
        if(name === undefined) throw new Error('name is a required argument')
        const name_arg = `name:"${name}",`
        const thingId_arg = thingId !== undefined ? thingId === null ? `thingId: null,` : `thingId:"${thingId}",` : ''
        const developerOnly_arg = developerOnly !== undefined ? developerOnly === null ? `developerOnly: null,` : `developerOnly:${developerOnly},` : ''
        const unitOfMeasurement_arg = unitOfMeasurement !== undefined ? unitOfMeasurement === null ? `unitOfMeasurement: null,` : `unitOfMeasurement:"${unitOfMeasurement}",` : ''
        const precision_arg = precision !== undefined ? precision === null ? `precision: null,` : `precision:${precision},` : ''
        const min_arg = min !== undefined ? min === null ? `min: null,` : `min:${min},` : ''
        const max_arg = max !== undefined ? max === null ? `max: null,` : `max:${max},` : ''
        const index_arg = index !== undefined ? index === null ? `index: null,` : `index:${index},` : ''
        const shownNodes_arg = shownNodes !== undefined ? shownNodes === null ? `shownNodes: null,` : `shownNodes:${shownNodes},` : ''
        const storedNodes_arg = storedNodes !== undefined ? storedNodes === null ? `storedNodes: null,` : `storedNodes:${storedNodes},` : ''
        return this.client.mutate({ mutation:gql(`mutation{createFloatSeriesVariable(${thingId_arg}${developerOnly_arg}${unitOfMeasurement_arg}${precision_arg}${min_arg}${max_arg}${name_arg}${index_arg}${shownNodes_arg}${storedNodes_arg}){id}}`) }).then(res=>res.data.createFloatSeriesVariable)
        }
    
    async createFloatSeriesNode ({seriesId, timestamp, value}) {
        if(seriesId === undefined) throw new Error('seriesId is a required argument')
        const seriesId_arg = `seriesId:"${seriesId}",`
        const timestamp_arg = timestamp !== undefined ? timestamp === null ? `timestamp: null,` : `timestamp:${timestamp},` : ''
        const value_arg = value !== undefined ? value === null ? `value: null,` : `value:${value},` : ''
        return this.client.mutate({ mutation:gql(`mutation{createFloatSeriesNode(${seriesId_arg}${timestamp_arg}${value_arg}){id}}`) }).then(res=>res.data.createFloatSeriesNode)
        }
    
    async updateUser ({companyName, quietMode, name, vatNumber, lengthAndMass, temperature, dateFormat, timeFormat, passwordChangeEmail, accessTokenCreatedEmail, addressLine1, addressLine2, addressPostalCode, addressCity, addressState, addressCountryOrTerritory, language}) {
        
        const companyName_arg = companyName !== undefined ? companyName === null ? `companyName: null,` : `companyName:"${companyName}",` : ''
        const quietMode_arg = quietMode !== undefined ? quietMode === null ? `quietMode: null,` : `quietMode:${quietMode},` : ''
        const name_arg = name !== undefined ? name === null ? `name: null,` : `name:"${name}",` : ''
        const vatNumber_arg = vatNumber !== undefined ? vatNumber === null ? `vatNumber: null,` : `vatNumber:"${vatNumber}",` : ''
        const lengthAndMass_arg = lengthAndMass !== undefined ? lengthAndMass === null ? `lengthAndMass: null,` : `lengthAndMass:${lengthAndMass},` : ''
        const temperature_arg = temperature !== undefined ? temperature === null ? `temperature: null,` : `temperature:${temperature},` : ''
        const dateFormat_arg = dateFormat !== undefined ? dateFormat === null ? `dateFormat: null,` : `dateFormat:${dateFormat},` : ''
        const timeFormat_arg = timeFormat !== undefined ? timeFormat === null ? `timeFormat: null,` : `timeFormat:${timeFormat},` : ''
        const passwordChangeEmail_arg = passwordChangeEmail !== undefined ? passwordChangeEmail === null ? `passwordChangeEmail: null,` : `passwordChangeEmail:${passwordChangeEmail},` : ''
        const accessTokenCreatedEmail_arg = accessTokenCreatedEmail !== undefined ? accessTokenCreatedEmail === null ? `accessTokenCreatedEmail: null,` : `accessTokenCreatedEmail:${accessTokenCreatedEmail},` : ''
        const addressLine1_arg = addressLine1 !== undefined ? addressLine1 === null ? `addressLine1: null,` : `addressLine1:"${addressLine1}",` : ''
        const addressLine2_arg = addressLine2 !== undefined ? addressLine2 === null ? `addressLine2: null,` : `addressLine2:"${addressLine2}",` : ''
        const addressPostalCode_arg = addressPostalCode !== undefined ? addressPostalCode === null ? `addressPostalCode: null,` : `addressPostalCode:"${addressPostalCode}",` : ''
        const addressCity_arg = addressCity !== undefined ? addressCity === null ? `addressCity: null,` : `addressCity:"${addressCity}",` : ''
        const addressState_arg = addressState !== undefined ? addressState === null ? `addressState: null,` : `addressState:"${addressState}",` : ''
        const addressCountryOrTerritory_arg = addressCountryOrTerritory !== undefined ? addressCountryOrTerritory === null ? `addressCountryOrTerritory: null,` : `addressCountryOrTerritory:"${addressCountryOrTerritory}",` : ''
        const language_arg = language !== undefined ? language === null ? `language: null,` : `language:"${language}",` : ''
        return this.client.mutate({ mutation:gql(`mutation{updateUser(${companyName_arg}${quietMode_arg}${name_arg}${vatNumber_arg}${lengthAndMass_arg}${temperature_arg}${dateFormat_arg}${timeFormat_arg}${passwordChangeEmail_arg}${accessTokenCreatedEmail_arg}${addressLine1_arg}${addressLine2_arg}${addressPostalCode_arg}${addressCity_arg}${addressState_arg}${addressCountryOrTerritory_arg}${language_arg}){id}}`) }).then(res=>res.data.updateUser)
        }
    
    async changeEmail ({newEmail, password, redirectTo}) {
        if(newEmail === undefined) throw new Error('newEmail is a required argument')
        const newEmail_arg = `newEmail:"${newEmail}",`
        if(password === undefined) throw new Error('password is a required argument')
        const password_arg = `password:"${password}",`
        if(redirectTo === undefined) throw new Error('redirectTo is a required argument')
        const redirectTo_arg = `redirectTo:${redirectTo},`
        
        return this.client.mutate({ mutation:gql(`mutation{changeEmail(${newEmail_arg}${password_arg}${redirectTo_arg})}`) }).then(res=>res.data.changeEmail)
        }
    
    async updateCollection ({id, name, picture, index, muted}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        const name_arg = name !== undefined ? name === null ? `name: null,` : `name:"${name}",` : ''
        const picture_arg = picture !== undefined ? picture === null ? `picture: null,` : `picture:${picture},` : ''
        const index_arg = index !== undefined ? index === null ? `index: null,` : `index:${index},` : ''
        const muted_arg = muted !== undefined ? muted === null ? `muted: null,` : `muted:${muted},` : ''
        return this.client.mutate({ mutation:gql(`mutation{updateCollection(${id_arg}${name_arg}${picture_arg}${index_arg}${muted_arg}){id}}`) }).then(res=>res.data.updateCollection)
        }
    
    async updateThing ({id, type, name, index, signal, battery, batteryCharging, firmware, muted, starred, storedNotifications, online}) {
        
        const id_arg = id !== undefined ? id === null ? `id: null,` : `id:"${id}",` : ''
        const type_arg = type !== undefined ? type === null ? `type: null,` : `type:"${type}",` : ''
        const name_arg = name !== undefined ? name === null ? `name: null,` : `name:"${name}",` : ''
        const index_arg = index !== undefined ? index === null ? `index: null,` : `index:${index},` : ''
        const signal_arg = signal !== undefined ? signal === null ? `signal: null,` : `signal:${signal},` : ''
        const battery_arg = battery !== undefined ? battery === null ? `battery: null,` : `battery:${battery},` : ''
        const batteryCharging_arg = batteryCharging !== undefined ? batteryCharging === null ? `batteryCharging: null,` : `batteryCharging:${batteryCharging},` : ''
        const firmware_arg = firmware !== undefined ? firmware === null ? `firmware: null,` : `firmware:"${firmware}",` : ''
        const muted_arg = muted !== undefined ? muted === null ? `muted: null,` : `muted:${muted},` : ''
        const starred_arg = starred !== undefined ? starred === null ? `starred: null,` : `starred:${starred},` : ''
        const storedNotifications_arg = storedNotifications !== undefined ? storedNotifications === null ? `storedNotifications: null,` : `storedNotifications:${storedNotifications},` : ''
        const online_arg = online !== undefined ? online === null ? `online: null,` : `online:${online},` : ''
        return this.client.mutate({ mutation:gql(`mutation{updateThing(${id_arg}${type_arg}${name_arg}${index_arg}${signal_arg}${battery_arg}${batteryCharging_arg}${firmware_arg}${muted_arg}${starred_arg}${storedNotifications_arg}${online_arg}){id}}`) }).then(res=>res.data.updateThing)
        }
    
    async moveThing ({thingId, newCollectionId}) {
        if(thingId === undefined) throw new Error('thingId is a required argument')
        const thingId_arg = `thingId:"${thingId}",`
        if(newCollectionId === undefined) throw new Error('newCollectionId is a required argument')
        const newCollectionId_arg = `newCollectionId:"${newCollectionId}",`
        
        return this.client.mutate({ mutation:gql(`mutation{moveThing(${thingId_arg}${newCollectionId_arg}){id}}`) }).then(res=>res.data.moveThing)
        }
    
    async updateVariable ({id, developerOnly, hidden, name, index}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        const developerOnly_arg = developerOnly !== undefined ? developerOnly === null ? `developerOnly: null,` : `developerOnly:${developerOnly},` : ''
        const hidden_arg = hidden !== undefined ? hidden === null ? `hidden: null,` : `hidden:${hidden},` : ''
        const name_arg = name !== undefined ? name === null ? `name: null,` : `name:"${name}",` : ''
        const index_arg = index !== undefined ? index === null ? `index: null,` : `index:${index},` : ''
        return this.client.mutate({ mutation:gql(`mutation{updateVariable(${id_arg}${developerOnly_arg}${hidden_arg}${name_arg}${index_arg}){id}}`) }).then(res=>res.data.updateVariable)
        }
    
    async updateFloatVariable ({id, userPermission, developerOnly, hidden, unitOfMeasurement, value, precision, min, max, name, index, allowedValues}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        const userPermission_arg = userPermission !== undefined ? userPermission === null ? `userPermission: null,` : `userPermission:${userPermission},` : ''
        const developerOnly_arg = developerOnly !== undefined ? developerOnly === null ? `developerOnly: null,` : `developerOnly:${developerOnly},` : ''
        const hidden_arg = hidden !== undefined ? hidden === null ? `hidden: null,` : `hidden:${hidden},` : ''
        const unitOfMeasurement_arg = unitOfMeasurement !== undefined ? unitOfMeasurement === null ? `unitOfMeasurement: null,` : `unitOfMeasurement:"${unitOfMeasurement}",` : ''
        const value_arg = value !== undefined ? value === null ? `value: null,` : `value:${value},` : ''
        const precision_arg = precision !== undefined ? precision === null ? `precision: null,` : `precision:${precision},` : ''
        const min_arg = min !== undefined ? min === null ? `min: null,` : `min:${min},` : ''
        const max_arg = max !== undefined ? max === null ? `max: null,` : `max:${max},` : ''
        const name_arg = name !== undefined ? name === null ? `name: null,` : `name:"${name}",` : ''
        const index_arg = index !== undefined ? index === null ? `index: null,` : `index:${index},` : ''
        const allowedValues_arg = allowedValues !== undefined ? allowedValues === null ? `allowedValues: null,` : `allowedValues:${allowedValues},` : ''
        return this.client.mutate({ mutation:gql(`mutation{updateFloatVariable(${id_arg}${userPermission_arg}${developerOnly_arg}${hidden_arg}${unitOfMeasurement_arg}${value_arg}${precision_arg}${min_arg}${max_arg}${name_arg}${index_arg}${allowedValues_arg}){id}}`) }).then(res=>res.data.updateFloatVariable)
        }
    
    async incrementFloatVariable ({id, incrementBy}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        if(incrementBy === undefined) throw new Error('incrementBy is a required argument')
        const incrementBy_arg = `incrementBy:${incrementBy},`
        
        return this.client.mutate({ mutation:gql(`mutation{incrementFloatVariable(${id_arg}${incrementBy_arg}){id}}`) }).then(res=>res.data.incrementFloatVariable)
        }
    
    async updateStringVariable ({id, userPermission, developerOnly, hidden, value, maxCharacters, name, allowedValues, index}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        const userPermission_arg = userPermission !== undefined ? userPermission === null ? `userPermission: null,` : `userPermission:${userPermission},` : ''
        const developerOnly_arg = developerOnly !== undefined ? developerOnly === null ? `developerOnly: null,` : `developerOnly:${developerOnly},` : ''
        const hidden_arg = hidden !== undefined ? hidden === null ? `hidden: null,` : `hidden:${hidden},` : ''
        const value_arg = value !== undefined ? value === null ? `value: null,` : `value:"${value}",` : ''
        const maxCharacters_arg = maxCharacters !== undefined ? maxCharacters === null ? `maxCharacters: null,` : `maxCharacters:${maxCharacters},` : ''
        const name_arg = name !== undefined ? name === null ? `name: null,` : `name:"${name}",` : ''
        const allowedValues_arg = allowedValues !== undefined ? allowedValues === null ? `allowedValues: null,` : `allowedValues:${allowedValues},` : ''
        const index_arg = index !== undefined ? index === null ? `index: null,` : `index:${index},` : ''
        return this.client.mutate({ mutation:gql(`mutation{updateStringVariable(${id_arg}${userPermission_arg}${developerOnly_arg}${hidden_arg}${value_arg}${maxCharacters_arg}${name_arg}${allowedValues_arg}${index_arg}){id}}`) }).then(res=>res.data.updateStringVariable)
        }
    
    async updateBooleanVariable ({id, userPermission, developerOnly, hidden, value, name, index}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        const userPermission_arg = userPermission !== undefined ? userPermission === null ? `userPermission: null,` : `userPermission:${userPermission},` : ''
        const developerOnly_arg = developerOnly !== undefined ? developerOnly === null ? `developerOnly: null,` : `developerOnly:${developerOnly},` : ''
        const hidden_arg = hidden !== undefined ? hidden === null ? `hidden: null,` : `hidden:${hidden},` : ''
        const value_arg = value !== undefined ? value === null ? `value: null,` : `value:${value},` : ''
        const name_arg = name !== undefined ? name === null ? `name: null,` : `name:"${name}",` : ''
        const index_arg = index !== undefined ? index === null ? `index: null,` : `index:${index},` : ''
        return this.client.mutate({ mutation:gql(`mutation{updateBooleanVariable(${id_arg}${userPermission_arg}${developerOnly_arg}${hidden_arg}${value_arg}${name_arg}${index_arg}){id}}`) }).then(res=>res.data.updateBooleanVariable)
        }
    
    async updateFloatSeriesVariable ({id, developerOnly, hidden, unitOfMeasurement, precision, min, max, name, index, shownNodes, storedNodes}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        const developerOnly_arg = developerOnly !== undefined ? developerOnly === null ? `developerOnly: null,` : `developerOnly:${developerOnly},` : ''
        const hidden_arg = hidden !== undefined ? hidden === null ? `hidden: null,` : `hidden:${hidden},` : ''
        const unitOfMeasurement_arg = unitOfMeasurement !== undefined ? unitOfMeasurement === null ? `unitOfMeasurement: null,` : `unitOfMeasurement:"${unitOfMeasurement}",` : ''
        const precision_arg = precision !== undefined ? precision === null ? `precision: null,` : `precision:${precision},` : ''
        const min_arg = min !== undefined ? min === null ? `min: null,` : `min:${min},` : ''
        const max_arg = max !== undefined ? max === null ? `max: null,` : `max:${max},` : ''
        const name_arg = name !== undefined ? name === null ? `name: null,` : `name:"${name}",` : ''
        const index_arg = index !== undefined ? index === null ? `index: null,` : `index:${index},` : ''
        const shownNodes_arg = shownNodes !== undefined ? shownNodes === null ? `shownNodes: null,` : `shownNodes:${shownNodes},` : ''
        const storedNodes_arg = storedNodes !== undefined ? storedNodes === null ? `storedNodes: null,` : `storedNodes:${storedNodes},` : ''
        return this.client.mutate({ mutation:gql(`mutation{updateFloatSeriesVariable(${id_arg}${developerOnly_arg}${hidden_arg}${unitOfMeasurement_arg}${precision_arg}${min_arg}${max_arg}${name_arg}${index_arg}${shownNodes_arg}${storedNodes_arg}){id}}`) }).then(res=>res.data.updateFloatSeriesVariable)
        }
    
    async updateFloatSeriesNode ({id, value, timestamp}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        const value_arg = value !== undefined ? value === null ? `value: null,` : `value:${value},` : ''
        const timestamp_arg = timestamp !== undefined ? timestamp === null ? `timestamp: null,` : `timestamp:${timestamp},` : ''
        return this.client.mutate({ mutation:gql(`mutation{updateFloatSeriesNode(${id_arg}${value_arg}${timestamp_arg}){id}}`) }).then(res=>res.data.updateFloatSeriesNode)
        }
    
    async updateNotification ({id, content, read}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        const content_arg = content !== undefined ? content === null ? `content: null,` : `content:"${content}",` : ''
        const read_arg = read !== undefined ? read === null ? `read: null,` : `read:${read},` : ''
        return this.client.mutate({ mutation:gql(`mutation{updateNotification(${id_arg}${content_arg}${read_arg}){id}}`) }).then(res=>res.data.updateNotification)
        }
    
    async deleteNotification ({id}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        
        return this.client.mutate({ mutation:gql(`mutation{deleteNotification(${id_arg})}`) }).then(res=>res.data.deleteNotification)
        }
    
    async deleteVariable ({id}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        
        return this.client.mutate({ mutation:gql(`mutation{deleteVariable(${id_arg})}`) }).then(res=>res.data.deleteVariable)
        }
    
    async deleteThing ({id}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        
        return this.client.mutate({ mutation:gql(`mutation{deleteThing(${id_arg})}`) }).then(res=>res.data.deleteThing)
        }
    
    async unpairThing ({reset, id}) {
        if(reset === undefined) throw new Error('reset is a required argument')
        const reset_arg = `reset:${reset},`
        const id_arg = id !== undefined ? id === null ? `id: null,` : `id:"${id}",` : ''
        return this.client.mutate({ mutation:gql(`mutation{unpairThing(${id_arg}${reset_arg}){id}}`) }).then(res=>res.data.unpairThing)
        }
    
    async deleteCollection ({id}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        
        return this.client.mutate({ mutation:gql(`mutation{deleteCollection(${id_arg})}`) }).then(res=>res.data.deleteCollection)
        }
    
    async deleteUser ({password}) {
        if(password === undefined) throw new Error('password is a required argument')
        const password_arg = `password:"${password}",`
        
        return this.client.mutate({ mutation:gql(`mutation{deleteUser(${password_arg})}`) }).then(res=>res.data.deleteUser)
        }
    
    async deleteFloatSeriesNode ({id}) {
        if(id === undefined) throw new Error('id is a required argument')
        const id_arg = `id:"${id}",`
        
        return this.client.mutate({ mutation:gql(`mutation{deleteFloatSeriesNode(${id_arg})}`) }).then(res=>res.data.deleteFloatSeriesNode)
        }
    }